import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Typography, Icon, Row, Col, Tabs, Table, Input, Select, DatePicker, Form, Spin, message, Modal } from 'antd';
import { Queries, Mutations } from '../../../graphql'
import Container from '../../../components/user/Container'
import FormInputAddress from '../../../components/user/FormInputAddress'
import TabsBlockProFile from '../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../config/datasetsProfile'
import { checkType } from '../../../utils/checkType'
import { changeFormatdate, changeYear } from '../../../utils/formatdate'
import { numberWithCommas } from '../../../utils/number'
import moment from 'moment'
import { textStatus } from '../../../utils/childEducationFee'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const newsDataProfile = '';

class Address extends Component {
	state = {
		loading:true,
        detailForm:null,
        dataTalbePeople: [],
        columnsPeople: [
            {
                title: 'ลำดับ',
                dataIndex: 'docId',
                width:'8%',
				align:'center',
                render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
            },
            {
                title: 'วันที่ทำรายการ',
                dataIndex: 'transactionDate',
                width:'20%',
                align:'center',
                // render: (item, record, index) => <span>{moment(item).format('DD-MM-YYYY')}</span>
                render: (item, record, index) => <span>{changeFormatdate(item)}</span>
            },
            {
                title: 'ผู้ดำเนินรายการ',
                dataIndex: 'transactionBy',
                width:'200px',
				align:'center',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'สถานะ',
                dataIndex: 'status',
                width:'200px',
				align:'center',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'หมายเหตุ',
                dataIndex: 'remark',
                width:'200px',
				align:'center',
                render: (item, record, index) => <>
                    {
                        item ?
                            <span 
                                onClick={()=>{this.showModalNode(item)}} 
                                style={{ cursor:"pointer" }}
                            > 
                                อ่านหมายเหตุ
                            </span>
                        : '-'
                    }
                   
                </>
            },
        ],
        loadingColumnsPeople:false,
        showModalNote:false,
        noteModal:null,
        pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
	}

    showModalNode = (item) => {
        this.setState({
            showModalNote: true,
            noteModal:item
        });
    };

    fetchListChildTuitions = async () =>{
        await this.setState({
            loading: true
        })

        const { client, match } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListChildTuitions,
            variables: {
                tuitionDTID:match.url.split('/')[3]
            }
        })

        ////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        if(data.fetchListChildTuitions){
            await this.setState({
                detailForm: data.fetchListChildTuitions[0],
                loading: false,
                dataTalbePeople : data.fetchListChildTuitions[0].childTuitionHistory
            })
        }
    }

	async componentDidMount(){
		await this.fetchListData()
    }

	render() {
		const { history, location, match, staticContext } = this.props
		const { 
            dataTalbe,
            columns,
            loading,
            detailForm,
            loadingColumnsPeople,
            dataTalbePeople,
            columnsPeople,
            showModalNote,
            noteModal
         } = this.state
         console.log('dataTalbePeople',dataTalbePeople)
		return (
			<Container match={match}>
                <Modal
                    visible={showModalNote}
                    title={"หมายเหตุ"}
                    // onOk={this.handleOk}
                    onCancel={ async()=>{
                        await this.setState({
                            showModalNote:false
                        })
                    }}
                    footer={[]}
                >
                    <p>{noteModal}</p>
                </Modal>
				<div className="card-container" id="page-profile">
                    <div className="px-5 py-5 card-bg-green">
                        {
                            !loading &&
                                <Tabs type="card">
                                    <TabPane tab={'รายละเอียดค่าการศึกษา'} key="1" className="mb-0">
                                        {
                                            detailForm ?
                                                <>
                                                    <Row gutter={16}>
                                                        <Col span={24} className="mb-4">
                                                            <span className="color-gray">เลขที่เอกสาร</span>
                                                            <Title className="color-blue-green mt-1" level={4} style={{ position:"relative" }}>
                                                                { detailForm.documentNo }
                                                                <span className={'ml-4 color-gray text-detail-status '+textStatus(detailForm.eduStatus,true)}>
                                                                    { textStatus(detailForm.eduStatus) }
                                                                </span>
                                                            </Title>
                                                            {/* <span className="color-gray">
                                                                { changeFormatdate(detailForm.documentCreatedDate) }
                                                            </span> */}
                                                        </Col>
                                                        <Col span={24} className="mt-4" style={{ position:"relative" }}>
                                                            <div style={{ display:"inline-block" }} className="pr-4" style={{ display:"inline-block", backgroundColor:"#fff", zIndex:"1", position:"relative" }}>
                                                                <Title className="color-gray " level={4} style={{ position:"relative" }}>
                                                                    บุตรคนที่ { detailForm.childNo }
                                                                        {
                                                                            detailForm.academyType &&
                                                                            <p className="ml-3 mb-0" style={{ display:"inline-block", fontSize:"13px" }}>
                                                                                ประเภทสถานศึกษา {detailForm.academyType}
                                                                            </p>
                                                                        }
                                                                        {
                                                                            detailForm.eduPeriod &&
                                                                            <p className="ml-2 mb-0" style={{ display:"inline-block", fontSize:"13px" }}>
                                                                                ครั้งที่ {detailForm.eduPeriod}
                                                                            </p>
                                                                        }
                                                                </Title>
                                                            </div>
                                                            <div className="line-center-div"></div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} className="mt-4">
                                                        <Col span={7}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ชื่อ - นามสกุล</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.childFullName ? detailForm.childFullName : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={7} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ระดับการศึกษา</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.educationLevel ? detailForm.educationLevel : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={3} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ระดับชั้น</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.eduGrade ? detailForm.eduGrade : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={4} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ปีการศึกษา</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.eduYear ? detailForm.eduYear : '-' }
                                                            </div>
                                                        </Col>
                                                        <Col span={3} align={"center"}>
                                                            <b style={{ fontSize:"12px" }} className="color-gray">ภาคเรียน</b>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                { detailForm.semaster ? detailForm.semaster : '-' }
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} className="mt-4">
                                                        <Col span={24}>
                                                            <div className="block-input-detail ant-input mt-1">
                                                                <p style={{ color:"#fa6c5c",display:"inline-block",width:"50%" }} className="mb-0">
                                                                    วันที่จ่าย : {  changeFormatdate(detailForm.payDate) }
                                                                </p>
                                                                <div align={"right"} style={{ display:"inline-block",width:"50%" }}>
                                                                    <p style={{ display:"inline-block"  }} className=" mb-0 mr-5">จำนวนเงิน</p>
                                                                    <p className="color-blue-green mb-0"  style={{ display:"inline-block" }}>
                                                                        {  numberWithCommas(detailForm.amount) }
                                                                    </p>
                                                                    <p  style={{ display:"inline-block"  }} className="mb-0 ml-3">บาท</p>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16} type="flex" justify="left" align="top" className="mt-5" >
                                                        <Col xs={24} md={24} className="pt-2 mb-4">
                                                            <strong className="color-red">
                                                                ประวัติการอนุมัติค่าการศึกษาบุตร
                                                            </strong>
                                                            <Table
                                                                columns={columnsPeople}
                                                                dataSource={dataTalbePeople}
                                                                pagination={false}
                                                                loading={loadingColumnsPeople}
                                                                locale={{ emptyText: 'ไม่พบข้อมูล' }}
                                                                className="mt-4"
                                                                bordered
                                                                rowCount={dataTalbePeople.length}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                            :
                                            <Row gutter={16} className="mt-4">
                                                <Col span={24} align="center">
                                                    <p>ไม่พบข้อมูลรายละเอียดค่าการศึกษา</p>
                                                </Col>
                                            </Row>
                                        }
                                    </TabPane>
                                </Tabs>
                            ||
                            <Row>
                                <Col align="center">
                                    <Spin size="small" />
                                </Col>
                            </Row>
                        }
                       
                    </div>
				</div>
			</Container>
		)
	}
}

Address.propTypes = {
	//
}

export default withApollo(Address)
